export default {"src":"/kaimono/_next/static/media/tw_hk_wamazing_snow_h.65bdd703.svg","height":116,"width":313};